import type { Picture } from 'app/typings';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

export const DEFAULT_KIND = 'sourcing';

export const pictureViewToPicture = (pic: PictureView): Picture => ({
  id: pic.id,
  name: pic.name || '',
  pictureId: pic.path,
  size: pic.size || 0,
  dimensions: pic.dimensions,
  alt: pic.alt,
  credit: pic.credit,
  updatedAt: safeToISOString(pic.updatedAt),
  kind: DEFAULT_KIND,
});

export const pictureToPictureView = (pic: Picture): PictureView => ({
  id: pic.id,
  createdAt: new Date(),
  updatedAt: new Date(pic.updatedAt),
  path: pic.pictureId,
  name: pic.name,
  size: pic.size,
  dimensions: pic.dimensions,
  alt: pic.alt,
  credit: pic.credit,
});

const safeToISOString = (value?: string | Date | null) => {
  if (!value) {
    return new Date().toISOString();
  }

  const d = new Date(value);

  return isNaN(d.getTime()) ? new Date().toISOString() : d.toISOString();
};
